import * as React from 'react';
const Forbidden = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => (
  <svg
    width={300}
    height={249}
    viewBox='0 0 404 249'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M316.902 247C338.807 220.926 352 187.29 352 150.571C352 67.7286 284.843 0.571289 202 0.571289C119.157 0.571289 52 67.7286 52 150.571C52 187.29 65.1931 220.926 87.0976 247H316.902Z'
      fill='#F0F3FC'
    />
    <g opacity={0.15}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M288.579 108.909C288.415 109.103 288.309 109.34 288.272 109.591L283.451 142.407C283.36 143.021 283.695 143.62 284.266 143.865L288.579 145.713C288.646 145.742 288.713 145.764 288.78 145.782C288.963 145.829 289.119 145.978 289.119 146.167V156.29C289.119 156.669 289.425 156.975 289.804 156.975C290.182 156.975 290.488 156.669 290.488 156.29V144.464C290.488 144.46 290.488 144.457 290.488 144.454L290.488 107.577C290.488 107.258 290.09 107.113 289.884 107.357L288.579 108.909Z'
        fill='#9D9FA4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M288.579 108.224C288.415 108.419 288.309 108.655 288.272 108.907L283.451 141.722C283.36 142.337 283.695 142.935 284.266 143.18L288.579 145.028C288.646 145.057 288.713 145.08 288.78 145.097C288.963 145.145 289.119 145.294 289.119 145.483V155.606C289.119 155.984 289.425 156.291 289.804 156.291C290.182 156.291 290.488 155.984 290.488 155.606V143.779C290.488 143.776 290.488 143.773 290.488 143.769L290.488 106.893C290.488 106.573 290.09 106.428 289.884 106.673L288.579 108.224Z'
        fill='#BCBEC4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M249.747 180.608C249.998 180.653 250.256 180.627 250.492 180.533L281.321 168.301C281.899 168.072 282.25 167.482 282.176 166.865L281.621 162.206C281.612 162.134 281.598 162.065 281.58 161.998C281.529 161.815 281.581 161.606 281.744 161.512L290.511 156.45C290.839 156.261 290.951 155.842 290.762 155.514C290.573 155.187 290.154 155.075 289.826 155.264L279.582 161.178C279.58 161.18 279.578 161.181 279.576 161.182L273.219 164.852L247.64 179.62C247.363 179.78 247.436 180.198 247.751 180.254L249.747 180.608Z'
        fill='#9D9FA4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M249.405 180.266C249.655 180.31 249.913 180.284 250.149 180.19L280.979 167.958C281.556 167.729 281.907 167.14 281.834 166.523L281.278 161.863C281.269 161.791 281.256 161.722 281.237 161.655C281.187 161.473 281.238 161.263 281.402 161.169L290.169 156.107C290.496 155.918 290.608 155.499 290.419 155.172C290.23 154.844 289.811 154.732 289.484 154.921L279.24 160.835C279.238 160.837 279.235 160.838 279.233 160.839L247.297 179.278C247.02 179.437 247.094 179.855 247.408 179.911L249.405 180.266Z'
        fill='#BCBEC4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M331.7 178.956C331.614 178.717 331.462 178.507 331.263 178.349L305.255 157.766C304.767 157.381 304.082 157.372 303.584 157.744L299.827 160.555C299.769 160.598 299.716 160.645 299.667 160.694C299.534 160.829 299.327 160.889 299.164 160.795L290.397 155.733C290.069 155.544 289.65 155.656 289.461 155.984C289.272 156.311 289.384 156.73 289.712 156.919L299.955 162.833C299.958 162.835 299.96 162.836 299.963 162.838L331.899 181.276C332.175 181.436 332.501 181.163 332.392 180.863L331.7 178.956Z'
        fill='#9D9FA4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M331.7 178.272C331.614 178.033 331.462 177.823 331.263 177.665L305.255 157.082C304.767 156.696 304.082 156.687 303.584 157.059L299.827 159.87C299.769 159.913 299.716 159.96 299.667 160.01C299.534 160.144 299.327 160.205 299.164 160.11L290.397 155.049C290.069 154.859 289.65 154.972 289.461 155.299C289.272 155.627 289.384 156.046 289.712 156.235L299.955 162.149C299.957 162.15 299.96 162.152 299.963 162.153L331.899 180.591C332.175 180.751 332.501 180.478 332.392 180.178L331.7 178.272Z'
        fill='#BCBEC4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M291.564 158.38C292.542 157.962 293.228 156.991 293.228 155.86C293.228 154.347 292.001 153.12 290.488 153.12C288.975 153.12 287.749 154.347 287.749 155.86C287.749 156.991 288.434 157.962 289.413 158.38L283.982 249H296.994L291.564 158.38Z'
        fill='#9D9FA4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M290.879 158.38C291.857 157.962 292.543 156.991 292.543 155.86C292.543 154.347 291.316 153.12 289.804 153.12C288.291 153.12 287.064 154.347 287.064 155.86C287.064 156.991 287.75 157.962 288.728 158.38L283.297 249H296.31L290.879 158.38Z'
        fill='#BCBEC4'
      />
    </g>
    <g opacity={0.6}>
      <rect
        x={56}
        y={123}
        width={26.7138}
        height={62.9968}
        rx={13.3569}
        fill='#E9EBF2'
      />
      <rect
        x={68.7588}
        y={148.518}
        width={1.59486}
        height={98.4823}
        rx={0.797428}
        fill='#E1E2E5'
      />
      <rect
        x={75.3384}
        y={152.02}
        width={1.59486}
        height={13.443}
        rx={0.797428}
        transform='rotate(30 75.3384 152.02)'
        fill='#E1E2E5'
      />
      <rect
        width={1.59486}
        height={18.9128}
        rx={0.797428}
        transform='matrix(0.866025 -0.5 -0.5 -0.866025 69.2009 173.49)'
        fill='#E1E2E5'
      />
    </g>
    <rect
      x={91}
      y={71}
      width={38.1994}
      height={90.0821}
      rx={19.0997}
      fill='#E9EBF2'
    />
    <rect
      x={109.245}
      y={107.489}
      width={2.28056}
      height={140.825}
      rx={1.14028}
      fill='#E1E2E5'
    />
    <rect
      x={118.653}
      y={112.496}
      width={2.28056}
      height={19.2228}
      rx={1.14028}
      transform='rotate(30 118.653 112.496)'
      fill='#E1E2E5'
    />
    <rect
      width={2.28056}
      height={27.0444}
      rx={1.14028}
      transform='matrix(0.866025 -0.5 -0.5 -0.866025 109.876 143.198)'
      fill='#E1E2E5'
    />
    <path
      opacity={0.8}
      fillRule='evenodd'
      clipRule='evenodd'
      d='M137 52.9322C137 53.001 136.999 53.0697 136.997 53.1381C141.285 53.2446 144.729 56.7541 144.729 61.0678C144.729 65.3806 141.287 68.8895 137 68.9974V69H136.804C136.802 69 136.799 69 136.797 69C136.794 69 136.791 69 136.789 69H121.136V68.9974C121.068 68.9991 121 69 120.932 69C116.551 69 113 65.4486 113 61.0678C113 56.687 116.551 53.1356 120.932 53.1356C121.001 53.1356 121.07 53.1365 121.138 53.1382C121.136 53.0698 121.136 53.0011 121.136 52.9322C121.136 48.5514 124.687 45 129.068 45C133.449 45 137 48.5514 137 52.9322Z'
      fill='white'
    />
    <path
      opacity={0.6}
      fillRule='evenodd'
      clipRule='evenodd'
      d='M271 71.6441C271 71.667 271 71.6899 270.999 71.7127C272.428 71.7482 273.576 72.918 273.576 74.3559C273.576 75.7935 272.429 76.9632 271 76.9991V77H270.935C270.934 77 270.933 77 270.932 77C270.931 77 270.93 77 270.929 77H265.712V76.9991C265.689 76.9997 265.667 77 265.644 77C264.184 77 263 75.8162 263 74.3559C263 72.8957 264.184 71.7119 265.644 71.7119C265.667 71.7119 265.69 71.7122 265.713 71.7127C265.712 71.6899 265.712 71.667 265.712 71.6441C265.712 70.1838 266.896 69 268.356 69C269.816 69 271 70.1838 271 71.6441Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M200.2 22.8281C200.2 15.7434 205.943 10 213.028 10C218.286 10 222.804 13.1628 224.786 17.6895C226.061 16.7876 227.617 16.2576 229.298 16.2576C233.252 16.2576 236.52 19.1909 237.046 23H239.98C243.57 23 246.48 25.9101 246.48 29.5C246.48 33.0898 243.57 36 239.98 36H201.5C197.91 36 195 33.0898 195 29.5C195 26.3541 197.235 23.7302 200.203 23.1293C200.201 23.0292 200.2 22.9288 200.2 22.8281Z'
      fill='white'
    />
    <path
      opacity={0.6}
      fillRule='evenodd'
      clipRule='evenodd'
      d='M159.121 91.2329C159.121 88.3429 161.464 86 164.354 86C166.499 86 168.342 87.2902 169.15 89.1367C169.67 88.7688 170.305 88.5526 170.991 88.5526C172.604 88.5526 173.937 89.7492 174.152 91.303H175.348C176.813 91.303 178 92.4902 178 93.9545C178 95.4189 176.813 96.6061 175.348 96.6061H159.652C158.187 96.6061 157 95.4189 157 93.9545C157 92.6713 157.912 91.6009 159.123 91.3558C159.122 91.3149 159.121 91.274 159.121 91.2329Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M317.382 28.7102C317.125 29.0162 316.957 29.3879 316.899 29.7835L309.318 81.3846C309.176 82.3513 309.702 83.2925 310.6 83.6774L317.382 86.5839C317.487 86.6288 317.593 86.6647 317.698 86.6921C317.986 86.7667 318.231 87.0013 318.231 87.2986V103.217C318.231 103.812 318.713 104.294 319.308 104.294C319.903 104.294 320.385 103.812 320.385 103.217V84.6189C320.385 84.6141 320.385 84.6092 320.385 84.6042L320.385 26.6167C320.385 26.1143 319.758 25.8856 319.434 26.2701L317.382 28.7102Z'
      fill='#DCDFE6'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M317.382 27.6331C317.125 27.9391 316.957 28.3107 316.899 28.7063L309.318 80.3075C309.176 81.2742 309.702 82.2154 310.6 82.6002L317.382 85.5068C317.487 85.5517 317.593 85.5876 317.698 85.615C317.986 85.6896 318.231 85.9242 318.231 86.2214V102.14C318.231 102.734 318.713 103.217 319.308 103.217C319.903 103.217 320.385 102.734 320.385 102.14V83.5418C320.385 83.5369 320.385 83.532 320.385 83.5271L320.385 25.5395C320.385 25.0371 319.758 24.8085 319.434 25.193L317.382 27.6331Z'
      fill='#E9EBF2'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M256.32 141.455C256.714 141.525 257.119 141.484 257.491 141.337L305.969 122.102C306.878 121.741 307.429 120.815 307.314 119.845L306.44 112.518C306.426 112.405 306.405 112.296 306.376 112.19C306.296 111.904 306.377 111.575 306.635 111.426L320.42 103.467C320.935 103.169 321.112 102.511 320.814 101.996C320.517 101.481 319.858 101.304 319.343 101.602L303.235 110.902C303.232 110.904 303.228 110.906 303.224 110.908L253.006 139.902C252.571 140.153 252.686 140.81 253.181 140.898L256.32 141.455Z'
      fill='#DCDFE6'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M255.782 140.916C256.175 140.986 256.581 140.945 256.952 140.798L305.431 121.563C306.339 121.202 306.891 120.276 306.775 119.306L305.902 111.979C305.888 111.866 305.866 111.756 305.837 111.651C305.758 111.365 305.839 111.036 306.096 110.887L319.882 102.928C320.397 102.63 320.573 101.972 320.276 101.457C319.979 100.942 319.32 100.765 318.805 101.063L302.697 110.363C302.693 110.365 302.69 110.367 302.686 110.369L252.467 139.363C252.032 139.614 252.148 140.271 252.642 140.359L255.782 140.916Z'
      fill='#E9EBF2'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M385.189 138.858C385.053 138.482 384.815 138.151 384.501 137.903L343.604 105.537C342.838 104.931 341.76 104.916 340.977 105.501L335.069 109.921C334.978 109.99 334.894 110.063 334.817 110.141C334.609 110.353 334.283 110.448 334.026 110.299L320.24 102.34C319.725 102.042 319.067 102.219 318.769 102.734C318.472 103.249 318.648 103.908 319.163 104.205L335.27 113.504C335.274 113.507 335.278 113.509 335.282 113.511L385.501 142.505C385.936 142.756 386.448 142.328 386.276 141.855L385.189 138.858Z'
      fill='#DCDFE6'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M385.189 137.781C385.053 137.405 384.815 137.074 384.501 136.826L343.604 104.46C342.838 103.854 341.76 103.839 340.977 104.424L335.069 108.844C334.978 108.913 334.894 108.986 334.817 109.064C334.609 109.276 334.283 109.37 334.026 109.222L320.24 101.263C319.725 100.965 319.067 101.142 318.769 101.657C318.472 102.172 318.648 102.831 319.163 103.128L335.27 112.427C335.274 112.43 335.278 112.432 335.282 112.434L385.501 141.428C385.936 141.679 386.448 141.25 386.276 140.778L385.189 137.781Z'
      fill='#E9EBF2'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M322.076 106.501C323.614 105.844 324.692 104.317 324.692 102.538C324.692 100.159 322.764 98.2305 320.385 98.2305C318.006 98.2305 316.077 100.159 316.077 102.538C316.077 104.317 317.155 105.844 318.693 106.501L310.154 249H330.615L322.076 106.501Z'
      fill='#DCDFE6'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M320.999 106.501C322.537 105.844 323.615 104.317 323.615 102.538C323.615 100.159 321.687 98.2305 319.308 98.2305C316.929 98.2305 315 100.159 315 102.538C315 104.317 316.078 105.844 317.616 106.501L309.077 249H329.538L320.999 106.501Z'
      fill='#E9EBF2'
    />
    <path
      d='M340.906 246H329.967C317.293 246 322.761 242.234 325.968 241.503C318.801 238.947 324.082 234.131 327.704 236.14C325.441 227.375 333.174 229.201 334.683 234.131C337.7 229.019 342.981 231.575 339.775 237.053C345.244 234.679 345.244 239.427 342.981 240.887C348.45 241.8 345.394 243.512 342.376 243.512C345.96 245.52 343.319 246 340.906 246Z'
      fill='#D7D8DE'
    />
    <path
      d='M292.906 246H281.967C269.293 246 274.761 242.234 277.968 241.503C270.801 238.947 276.082 234.131 279.704 236.14C277.441 227.375 285.174 229.201 286.683 234.131C289.7 229.019 294.981 231.575 291.775 237.053C297.244 234.679 297.244 239.427 294.981 240.887C300.45 241.8 297.394 243.512 294.376 243.512C297.96 245.52 295.319 246 292.906 246Z'
      fill='#D7D8DE'
    />
    <path
      d='M325.538 247H304.116C279.296 247 290.004 239.938 296.283 238.569C282.248 233.776 292.59 224.746 299.684 228.512C295.252 212.079 310.395 215.503 313.35 224.746C319.259 215.16 329.601 219.953 323.322 230.224C334.033 225.774 334.033 234.675 329.601 237.414C340.312 239.126 334.326 242.335 328.416 242.335C335.434 246.101 330.263 247 325.538 247Z'
      fill='#E1E1E6'
    />
    <path
      d='M282.403 226.831C282.26 225.833 281.842 224.83 280.992 224.143C282.981 224.205 283.738 224.746 284.561 225.553C286.552 227.504 285.486 229.886 284.318 229.504C283.151 229.123 282.551 227.865 282.403 226.831Z'
      fill='#E5E6ED'
    />
    <path
      d='M282.247 224.671C284.329 225.69 285.117 228.384 285.398 229.717L285.133 229.784C284.777 226.991 283.372 225.235 282.247 224.671C282.211 224.654 282.175 224.637 282.138 224.62C282.174 224.636 282.211 224.653 282.247 224.671Z'
      fill='#727785'
    />
    <path
      d='M284.141 225.4C284.484 225.829 284.38 226.487 284.305 226.802L284.242 226.789C284.448 226.154 284.325 225.635 284.141 225.4C284.135 225.393 284.129 225.385 284.123 225.378C284.129 225.385 284.135 225.392 284.141 225.4Z'
      fill='#727785'
    />
    <path
      d='M283.136 225.774C283.307 226.023 283.65 226.076 283.817 226.089L283.818 226.053C283.474 226.057 283.23 225.908 283.136 225.774C283.133 225.77 283.131 225.765 283.128 225.761C283.13 225.765 283.133 225.769 283.136 225.774Z'
      fill='#727785'
    />
    <path
      d='M284.96 226.39C285.181 226.894 284.911 227.503 284.758 227.787L284.7 227.759C285.063 227.198 285.077 226.665 284.96 226.39C284.956 226.382 284.952 226.373 284.948 226.364C284.952 226.373 284.956 226.381 284.96 226.39Z'
      fill='#727785'
    />
    <path
      d='M283.24 226.72C283.547 227.177 284.205 227.276 284.528 227.299L284.535 227.235C283.867 227.241 283.409 226.967 283.24 226.72C283.235 226.712 283.23 226.704 283.225 226.696C283.23 226.704 283.235 226.712 283.24 226.72Z'
      fill='#727785'
    />
    <path
      d='M283.228 227.768C283.655 228.432 284.542 228.599 284.975 228.644L284.982 228.552C284.087 228.536 283.463 228.127 283.228 227.768C283.22 227.757 283.213 227.745 283.206 227.733C283.213 227.745 283.22 227.757 283.228 227.768Z'
      fill='#727785'
    />
    <path
      d='M341.01 229.284C341.591 228.46 342.419 227.757 343.489 227.531C341.689 226.682 340.769 226.821 339.669 227.165C337.009 227.997 336.876 230.604 338.089 230.795C339.302 230.985 340.408 230.137 341.01 229.284Z'
      fill='#E5E6ED'
    />
    <path
      d='M342.13 227.432C339.814 227.393 337.887 229.434 337.031 230.494L337.236 230.674C338.823 228.347 340.872 227.422 342.13 227.432C342.17 227.432 342.211 227.434 342.251 227.436C342.211 227.433 342.171 227.432 342.13 227.432Z'
      fill='#727785'
    />
    <path
      d='M340.113 227.219C339.612 227.446 339.405 228.079 339.329 228.393L339.392 228.411C339.496 227.751 339.842 227.345 340.113 227.219C340.122 227.215 340.13 227.212 340.139 227.208C340.131 227.211 340.122 227.215 340.113 227.219Z'
      fill='#727785'
    />
    <path
      d='M340.837 228.01C340.572 228.154 340.243 228.046 340.088 227.981L340.103 227.949C340.408 228.109 340.693 228.087 340.837 228.01C340.842 228.007 340.847 228.005 340.851 228.002C340.847 228.005 340.842 228.007 340.837 228.01Z'
      fill='#727785'
    />
    <path
      d='M338.933 227.73C338.507 228.077 338.471 228.743 338.478 229.066L338.543 229.067C338.474 228.402 338.703 227.921 338.933 227.73C338.94 227.724 338.948 227.718 338.955 227.712C338.948 227.718 338.94 227.723 338.933 227.73Z'
      fill='#727785'
    />
    <path
      d='M340.315 228.805C339.834 229.073 339.203 228.862 338.905 228.736L338.928 228.675C339.52 228.984 340.053 228.948 340.315 228.805C340.323 228.801 340.331 228.796 340.339 228.791C340.331 228.796 340.323 228.801 340.315 228.805Z'
      fill='#727785'
    />
    <path
      d='M339.85 229.744C339.167 230.141 338.302 229.886 337.895 229.73L337.931 229.645C338.735 230.037 339.477 229.956 339.85 229.744C339.861 229.737 339.873 229.73 339.885 229.723C339.873 229.73 339.862 229.737 339.85 229.744Z'
      fill='#727785'
    />
    <path
      d='M318.101 212.924C318.171 211.918 318.516 210.888 319.313 210.14C317.335 210.346 316.619 210.942 315.856 211.806C314.012 213.896 315.249 216.195 316.386 215.729C317.522 215.264 318.029 213.965 318.101 212.924Z'
      fill='#E5E6ED'
    />
    <path
      d='M318.1 210.759C316.098 211.926 315.508 214.67 315.324 216.02L315.594 216.068C315.745 213.256 317.019 211.403 318.1 210.759C318.134 210.739 318.169 210.719 318.205 210.7C318.17 210.719 318.135 210.738 318.1 210.759Z'
      fill='#727785'
    />
    <path
      d='M316.264 211.623C315.953 212.076 316.105 212.725 316.202 213.033L316.265 213.016C316.012 212.397 316.098 211.871 316.264 211.623C316.27 211.615 316.275 211.607 316.281 211.6C316.275 211.607 316.27 211.615 316.264 211.623Z'
      fill='#727785'
    />
    <path
      d='M317.293 211.923C317.141 212.184 316.803 212.262 316.638 212.286L316.633 212.251C316.977 212.23 317.209 212.064 317.293 211.923C317.296 211.918 317.299 211.914 317.301 211.909C317.299 211.914 317.296 211.918 317.293 211.923Z'
      fill='#727785'
    />
    <path
      d='M315.52 212.67C315.336 213.188 315.649 213.776 315.823 214.049L315.879 214.016C315.475 213.484 315.422 212.953 315.52 212.67C315.523 212.661 315.526 212.652 315.53 212.644C315.526 212.652 315.523 212.661 315.52 212.67Z'
      fill='#727785'
    />
    <path
      d='M317.258 212.875C316.986 213.352 316.337 213.499 316.017 213.546L316.005 213.482C316.672 213.439 317.108 213.133 317.258 212.875C317.263 212.866 317.268 212.858 317.272 212.85C317.268 212.858 317.263 212.866 317.258 212.875Z'
      fill='#727785'
    />
    <path
      d='M317.347 213.918C316.969 214.612 316.097 214.842 315.668 214.919L315.655 214.828C316.546 214.746 317.139 214.293 317.347 213.918C317.354 213.906 317.36 213.894 317.366 213.882C317.36 213.894 317.354 213.906 317.347 213.918Z'
      fill='#727785'
    />
    <path
      d='M296.5 213.729C296.466 213.137 296.271 212.528 295.807 212.082C296.97 212.218 297.387 212.573 297.829 213.088C298.899 214.331 298.155 215.674 297.489 215.392C296.824 215.11 296.535 214.342 296.5 213.729Z'
      fill='#E5E6ED'
    />
    <path
      d='M296.517 212.455C297.686 213.157 298.013 214.775 298.111 215.571L297.953 215.597C297.884 213.942 297.148 212.842 296.517 212.455C296.497 212.443 296.476 212.431 296.456 212.42C296.476 212.431 296.496 212.443 296.517 212.455Z'
      fill='#727785'
    />
    <path
      d='M297.591 212.977C297.77 213.246 297.677 213.626 297.617 213.807L297.58 213.796C297.733 213.434 297.687 213.124 297.591 212.977C297.588 212.972 297.584 212.967 297.581 212.963C297.584 212.967 297.587 212.972 297.591 212.977Z'
      fill='#727785'
    />
    <path
      d='M296.983 213.146C297.071 213.3 297.269 213.349 297.366 213.364L297.369 213.344C297.167 213.329 297.031 213.229 296.983 213.146C296.981 213.143 296.98 213.14 296.979 213.138C296.98 213.14 296.981 213.143 296.983 213.146Z'
      fill='#727785'
    />
    <path
      d='M298.021 213.599C298.126 213.905 297.937 214.249 297.833 214.408L297.8 214.388C298.041 214.078 298.076 213.766 298.021 213.599C298.019 213.594 298.017 213.588 298.015 213.583C298.017 213.588 298.019 213.593 298.021 213.599Z'
      fill='#727785'
    />
    <path
      d='M296.996 213.706C297.153 213.989 297.534 214.08 297.722 214.11L297.73 214.073C297.338 214.043 297.083 213.859 296.996 213.706C296.994 213.701 296.991 213.696 296.989 213.691C296.991 213.696 296.994 213.701 296.996 213.706Z'
      fill='#727785'
    />
    <path
      d='M296.937 214.319C297.154 214.73 297.666 214.872 297.917 214.92L297.926 214.867C297.402 214.812 297.057 214.541 296.937 214.319C296.933 214.312 296.929 214.305 296.926 214.298C296.929 214.305 296.933 214.312 296.937 214.319Z'
      fill='#727785'
    />
    <path
      d='M74.5896 247H63.9758C51.6784 247 56.984 243.501 60.0949 242.822C53.141 240.448 58.2649 235.974 61.7798 237.84C59.5839 229.698 67.0867 231.394 68.5507 235.974C71.4786 231.224 76.6025 233.599 73.4916 238.688C78.7985 236.483 78.7985 240.893 76.6025 242.25C81.9094 243.098 78.9435 244.688 76.0156 244.688C79.4925 246.554 76.9306 247 74.5896 247Z'
      fill='#E9EBF2'
    />
    <path
      d='M80.4763 246.505H75.0565C68.777 246.505 71.4862 244.639 73.0747 244.277C69.5238 243.01 72.1403 240.624 73.9351 241.619C72.8138 237.277 76.645 238.181 77.3926 240.624C78.8877 238.091 81.5042 239.358 79.9156 242.072C82.6255 240.896 82.6255 243.248 81.5042 243.971C84.2141 244.424 82.6995 245.272 81.2044 245.272C82.9799 246.267 81.6717 246.505 80.4763 246.505Z'
      fill='#DFE0E6'
    />
    <path
      d='M56.2465 234.448C55.9587 234.04 55.5483 233.692 55.0183 233.58C55.9099 233.159 56.3659 233.228 56.9112 233.399C58.2291 233.811 58.295 235.102 57.6938 235.197C57.0925 235.291 56.5447 234.871 56.2465 234.448Z'
      fill='#E5E6ED'
    />
    <path
      d='M55.6914 233.53C56.8394 233.511 57.7939 234.522 58.2181 235.047L58.1162 235.137C57.3303 233.984 56.3147 233.526 55.6914 233.53C55.6716 233.531 55.6518 233.531 55.6318 233.532C55.6513 233.531 55.6712 233.53 55.6914 233.53Z'
      fill='#727785'
    />
    <path
      d='M56.691 233.426C56.9392 233.538 57.0415 233.851 57.0793 234.007L57.0484 234.016C56.9966 233.689 56.8252 233.488 56.691 233.426C56.6867 233.424 56.6824 233.422 56.678 233.42C56.6823 233.422 56.6866 233.424 56.691 233.426Z'
      fill='#727785'
    />
    <path
      d='M56.332 233.817C56.4635 233.889 56.6266 233.835 56.703 233.803L56.6959 233.787C56.5449 233.866 56.4037 233.855 56.332 233.817C56.3297 233.816 56.3274 233.815 56.3252 233.813C56.3274 233.815 56.3296 233.816 56.332 233.817Z'
      fill='#727785'
    />
    <path
      d='M57.2755 233.678C57.4865 233.85 57.5045 234.18 57.501 234.34L57.4688 234.34C57.503 234.011 57.3892 233.772 57.2755 233.678C57.2719 233.675 57.2682 233.672 57.2644 233.669C57.2681 233.672 57.2718 233.675 57.2755 233.678Z'
      fill='#727785'
    />
    <path
      d='M56.5911 234.211C56.8291 234.344 57.142 234.239 57.2896 234.177L57.2783 234.147C56.9848 234.3 56.721 234.282 56.5911 234.211C56.587 234.209 56.5829 234.207 56.5789 234.204C56.5828 234.207 56.5869 234.209 56.5911 234.211Z'
      fill='#727785'
    />
    <path
      d='M56.8214 234.676C57.1597 234.873 57.5883 234.747 57.7897 234.67L57.7722 234.627C57.3734 234.822 57.0059 234.782 56.8214 234.676C56.8155 234.673 56.8097 234.67 56.804 234.666C56.8096 234.67 56.8154 234.673 56.8214 234.676Z'
      fill='#727785'
    />
    <path
      d='M80.9786 237.916C81.2664 237.508 81.6768 237.16 82.2068 237.048C81.3152 236.627 80.8592 236.696 80.3139 236.866C78.996 237.279 78.9301 238.57 79.5313 238.665C80.1326 238.759 80.6804 238.339 80.9786 237.916Z'
      fill='#E5E6ED'
    />
    <path
      d='M81.5336 236.998C80.3857 236.979 79.4312 237.99 79.007 238.515L79.1089 238.604C79.8948 237.452 80.9104 236.993 81.5336 236.998C81.5535 236.998 81.5733 236.999 81.5933 237C81.5738 236.999 81.5539 236.998 81.5336 236.998Z'
      fill='#727785'
    />
    <path
      d='M80.5341 236.893C80.2859 237.006 80.1836 237.319 80.1458 237.475L80.1767 237.484C80.2285 237.157 80.3999 236.955 80.5341 236.893C80.5384 236.891 80.5427 236.89 80.5471 236.888C80.5428 236.889 80.5385 236.891 80.5341 236.893Z'
      fill='#727785'
    />
    <path
      d='M80.8931 237.285C80.7616 237.357 80.5985 237.303 80.5221 237.271L80.5292 237.255C80.6802 237.334 80.8214 237.323 80.8931 237.285C80.8954 237.284 80.8977 237.283 80.8999 237.281C80.8977 237.283 80.8955 237.284 80.8931 237.285Z'
      fill='#727785'
    />
    <path
      d='M79.9496 237.146C79.7386 237.318 79.7206 237.647 79.7241 237.807L79.7563 237.808C79.7221 237.479 79.8359 237.24 79.9496 237.146C79.9532 237.143 79.9569 237.14 79.9607 237.137C79.957 237.139 79.9533 237.142 79.9496 237.146Z'
      fill='#727785'
    />
    <path
      d='M80.634 237.679C80.396 237.812 80.0831 237.707 79.9355 237.645L79.9468 237.615C80.2403 237.768 80.5041 237.75 80.634 237.679C80.6381 237.677 80.6422 237.674 80.6462 237.672C80.6423 237.674 80.6382 237.677 80.634 237.679Z'
      fill='#727785'
    />
    <path
      d='M80.4037 238.144C80.0654 238.341 79.6368 238.215 79.4354 238.137L79.4529 238.095C79.8517 238.289 80.2192 238.25 80.4037 238.144C80.4095 238.141 80.4154 238.137 80.4211 238.134C80.4155 238.137 80.4097 238.141 80.4037 238.144Z'
      fill='#727785'
    />
    <path
      d='M69.914 232.098C69.9487 231.6 70.1193 231.089 70.5146 230.719C69.5341 230.821 69.1796 231.116 68.8016 231.544C67.888 232.58 68.5008 233.719 69.064 233.488C69.6271 233.257 69.878 232.614 69.914 232.098Z'
      fill='#E5E6ED'
    />
    <path
      d='M69.9133 231.025C68.9215 231.603 68.6291 232.963 68.5382 233.632L68.6716 233.655C68.7467 232.263 69.3778 231.344 69.9133 231.025C69.9305 231.015 69.9478 231.006 69.9653 230.996C69.9481 231.005 69.9308 231.015 69.9133 231.025Z'
      fill='#727785'
    />
    <path
      d='M69.0038 231.453C68.8496 231.678 68.9246 231.999 68.9729 232.152L69.0039 232.143C68.8789 231.837 68.9212 231.576 69.0038 231.453C69.0064 231.449 69.0092 231.445 69.012 231.441C69.0092 231.445 69.0065 231.449 69.0038 231.453Z'
      fill='#727785'
    />
    <path
      d='M69.5135 231.602C69.438 231.732 69.2708 231.77 69.1887 231.783L69.1866 231.765C69.3568 231.755 69.4719 231.672 69.5135 231.602C69.5148 231.6 69.5161 231.598 69.5173 231.596C69.5161 231.598 69.5149 231.6 69.5135 231.602Z'
      fill='#727785'
    />
    <path
      d='M68.6347 231.972C68.5435 232.229 68.6988 232.52 68.7848 232.655L68.8126 232.639C68.6128 232.375 68.5865 232.112 68.6347 231.972C68.6363 231.968 68.6379 231.963 68.6396 231.959C68.6379 231.963 68.6363 231.968 68.6347 231.972Z'
      fill='#727785'
    />
    <path
      d='M69.4964 232.074C69.3615 232.311 69.0396 232.383 68.8811 232.406L68.8752 232.375C69.2056 232.354 69.422 232.202 69.4964 232.074C69.4987 232.07 69.501 232.066 69.5032 232.062C69.5011 232.066 69.4988 232.07 69.4964 232.074Z'
      fill='#727785'
    />
    <path
      d='M69.5403 232.591C69.353 232.935 68.9209 233.049 68.7085 233.087L68.7016 233.042C69.1434 233.001 69.4371 232.777 69.5403 232.591C69.5436 232.585 69.5467 232.579 69.5498 232.573C69.5468 232.579 69.5437 232.585 69.5403 232.591Z'
      fill='#727785'
    />
    <path
      d='M59.4659 232.001C59.4491 231.708 59.3524 231.406 59.1226 231.185C59.6987 231.253 59.9051 231.429 60.1244 231.683C60.6544 232.299 60.2855 232.965 59.9558 232.825C59.6262 232.685 59.4833 232.305 59.4659 232.001Z'
      fill='#E5E6ED'
    />
    <path
      d='M59.4742 231.37C60.0536 231.718 60.2157 232.52 60.2642 232.914L60.1856 232.927C60.1516 232.107 59.787 231.562 59.4742 231.37C59.4642 231.364 59.4541 231.358 59.4438 231.353C59.4539 231.358 59.464 231.364 59.4742 231.37Z'
      fill='#727785'
    />
    <path
      d='M60.006 231.629C60.095 231.762 60.0485 231.951 60.019 232.04L60.0008 232.035C60.0767 231.856 60.0537 231.702 60.006 231.629C60.0044 231.627 60.0028 231.624 60.0012 231.622C60.0028 231.624 60.0044 231.627 60.006 231.629Z'
      fill='#727785'
    />
    <path
      d='M59.7051 231.712C59.7486 231.789 59.8467 231.813 59.8948 231.82L59.8963 231.81C59.7962 231.803 59.729 231.753 59.7051 231.712C59.7043 231.711 59.7036 231.709 59.7029 231.708C59.7036 231.709 59.7043 231.711 59.7051 231.712Z'
      fill='#727785'
    />
    <path
      d='M60.2194 231.937C60.2711 232.088 60.1776 232.258 60.1261 232.337L60.1098 232.328C60.2293 232.174 60.2467 232.019 60.2194 231.937C60.2185 231.934 60.2175 231.931 60.2166 231.929C60.2175 231.931 60.2185 231.934 60.2194 231.937Z'
      fill='#727785'
    />
    <path
      d='M59.7117 231.99C59.7893 232.13 59.9782 232.175 60.0712 232.19L60.0749 232.171C59.8807 232.156 59.7545 232.066 59.7117 231.99C59.7103 231.987 59.709 231.985 59.7078 231.982C59.709 231.985 59.7103 231.987 59.7117 231.99Z'
      fill='#727785'
    />
    <path
      d='M59.6822 232.294C59.7899 232.497 60.0433 232.568 60.168 232.592L60.1724 232.565C59.9127 232.538 59.7416 232.404 59.6822 232.294C59.6803 232.29 59.6785 232.287 59.6768 232.283C59.6785 232.287 59.6803 232.29 59.6822 232.294Z'
      fill='#727785'
    />
    <path
      d='M77.7595 235.47C77.7763 235.176 77.8729 234.875 78.1028 234.654C77.5266 234.721 77.3202 234.897 77.101 235.152C76.571 235.768 76.9398 236.434 77.2695 236.294C77.5991 236.154 77.7421 235.774 77.7595 235.47Z'
      fill='#E5E6ED'
    />
    <path
      d='M77.7511 234.839C77.1718 235.186 77.0097 235.988 76.9611 236.383L77.0397 236.395C77.0737 235.575 77.4383 235.03 77.7511 234.839C77.7611 234.833 77.7712 234.827 77.7815 234.821C77.7714 234.827 77.7613 234.833 77.7511 234.839Z'
      fill='#727785'
    />
    <path
      d='M77.2194 235.097C77.1303 235.23 77.1768 235.418 77.2063 235.508L77.2245 235.503C77.1487 235.323 77.1717 235.169 77.2194 235.097C77.2209 235.094 77.2225 235.092 77.2241 235.09C77.2225 235.092 77.2209 235.094 77.2194 235.097Z'
      fill='#727785'
    />
    <path
      d='M77.5203 235.181C77.4768 235.257 77.3787 235.281 77.3305 235.289L77.3291 235.279C77.4292 235.272 77.4963 235.222 77.5203 235.181C77.521 235.179 77.5217 235.178 77.5225 235.177C77.5218 235.178 77.521 235.179 77.5203 235.181Z'
      fill='#727785'
    />
    <path
      d='M77.006 235.405C76.9542 235.557 77.0477 235.727 77.0993 235.806L77.1155 235.796C76.996 235.643 76.9786 235.488 77.006 235.405C77.0069 235.403 77.0078 235.4 77.0088 235.397C77.0078 235.4 77.0069 235.403 77.006 235.405Z'
      fill='#727785'
    />
    <path
      d='M77.5137 235.459C77.4361 235.599 77.2472 235.644 77.1541 235.659L77.1504 235.64C77.3446 235.625 77.4708 235.534 77.5137 235.459C77.515 235.456 77.5163 235.454 77.5176 235.451C77.5164 235.454 77.5151 235.456 77.5137 235.459Z'
      fill='#727785'
    />
    <path
      d='M77.5431 235.763C77.4354 235.966 77.182 236.036 77.0574 236.06L77.053 236.034C77.3126 236.007 77.4837 235.873 77.5431 235.763C77.545 235.759 77.5468 235.756 77.5486 235.752C77.5469 235.755 77.5451 235.759 77.5431 235.763Z'
      fill='#727785'
    />
    <path
      d='M121.59 247H110.976C98.6784 247 103.984 243.501 107.095 242.822C100.141 240.448 105.265 235.974 108.78 237.84C106.584 229.698 114.087 231.394 115.551 235.974C118.479 231.224 123.603 233.599 120.492 238.688C125.799 236.483 125.799 240.893 123.603 242.25C128.909 243.098 125.943 244.688 123.016 244.688C126.493 246.554 123.931 247 121.59 247Z'
      fill='#E9EBF2'
    />
    <path
      d='M127.476 246.505H122.056C115.777 246.505 118.486 244.639 120.075 244.277C116.524 243.01 119.14 240.624 120.935 241.619C119.814 237.277 123.645 238.181 124.393 240.624C125.888 238.091 128.504 239.358 126.916 242.072C129.626 240.896 129.626 243.248 128.504 243.971C131.214 244.424 129.7 245.272 128.204 245.272C129.98 246.267 128.672 246.505 127.476 246.505Z'
      fill='#DFE0E6'
    />
    <path
      d='M103.247 234.448C102.959 234.04 102.548 233.692 102.018 233.58C102.91 233.159 103.366 233.228 103.911 233.399C105.229 233.811 105.295 235.102 104.694 235.197C104.093 235.291 103.545 234.871 103.247 234.448Z'
      fill='#E5E6ED'
    />
    <path
      d='M102.691 233.53C103.839 233.511 104.794 234.522 105.218 235.047L105.116 235.137C104.33 233.984 103.315 233.526 102.691 233.53C102.672 233.531 102.652 233.531 102.632 233.532C102.651 233.531 102.671 233.53 102.691 233.53Z'
      fill='#727785'
    />
    <path
      d='M103.691 233.426C103.939 233.538 104.041 233.851 104.079 234.007L104.048 234.016C103.997 233.689 103.825 233.488 103.691 233.426C103.687 233.424 103.682 233.422 103.678 233.42C103.682 233.422 103.687 233.424 103.691 233.426Z'
      fill='#727785'
    />
    <path
      d='M103.332 233.817C103.464 233.889 103.627 233.835 103.703 233.803L103.696 233.787C103.545 233.866 103.404 233.855 103.332 233.817C103.33 233.816 103.327 233.815 103.325 233.813C103.327 233.815 103.33 233.816 103.332 233.817Z'
      fill='#727785'
    />
    <path
      d='M104.276 233.678C104.486 233.85 104.505 234.18 104.501 234.34L104.469 234.34C104.503 234.011 104.389 233.772 104.276 233.678C104.272 233.675 104.268 233.672 104.264 233.669C104.268 233.672 104.272 233.675 104.276 233.678Z'
      fill='#727785'
    />
    <path
      d='M103.591 234.211C103.829 234.344 104.142 234.239 104.29 234.177L104.278 234.147C103.985 234.3 103.721 234.282 103.591 234.211C103.587 234.209 103.583 234.207 103.579 234.204C103.583 234.207 103.587 234.209 103.591 234.211Z'
      fill='#727785'
    />
    <path
      d='M103.821 234.676C104.16 234.873 104.588 234.747 104.79 234.67L104.772 234.627C104.373 234.822 104.006 234.782 103.821 234.676C103.816 234.673 103.81 234.67 103.804 234.666C103.81 234.67 103.815 234.673 103.821 234.676Z'
      fill='#727785'
    />
    <path
      d='M127.979 237.916C128.266 237.508 128.677 237.16 129.207 237.048C128.315 236.627 127.859 236.696 127.314 236.866C125.996 237.279 125.93 238.57 126.531 238.665C127.133 238.759 127.68 238.339 127.979 237.916Z'
      fill='#E5E6ED'
    />
    <path
      d='M128.534 236.998C127.386 236.979 126.431 237.99 126.007 238.515L126.109 238.604C126.895 237.452 127.91 236.993 128.534 236.998C128.553 236.998 128.573 236.999 128.593 237C128.574 236.999 128.554 236.998 128.534 236.998Z'
      fill='#727785'
    />
    <path
      d='M127.534 236.893C127.286 237.006 127.184 237.319 127.146 237.475L127.177 237.484C127.229 237.157 127.4 236.955 127.534 236.893C127.538 236.891 127.543 236.89 127.547 236.888C127.543 236.889 127.539 236.891 127.534 236.893Z'
      fill='#727785'
    />
    <path
      d='M127.893 237.285C127.762 237.357 127.598 237.303 127.522 237.271L127.529 237.255C127.68 237.334 127.821 237.323 127.893 237.285C127.895 237.284 127.898 237.283 127.9 237.281C127.898 237.283 127.895 237.284 127.893 237.285Z'
      fill='#727785'
    />
    <path
      d='M126.95 237.146C126.739 237.318 126.721 237.647 126.724 237.807L126.756 237.808C126.722 237.479 126.836 237.24 126.95 237.146C126.953 237.143 126.957 237.14 126.961 237.137C126.957 237.139 126.953 237.142 126.95 237.146Z'
      fill='#727785'
    />
    <path
      d='M127.634 237.679C127.396 237.812 127.083 237.707 126.936 237.645L126.947 237.615C127.24 237.768 127.504 237.75 127.634 237.679C127.638 237.677 127.642 237.674 127.646 237.672C127.642 237.674 127.638 237.677 127.634 237.679Z'
      fill='#727785'
    />
    <path
      d='M127.404 238.144C127.065 238.341 126.637 238.215 126.435 238.137L126.453 238.095C126.852 238.289 127.219 238.25 127.404 238.144C127.41 238.141 127.415 238.137 127.421 238.134C127.416 238.137 127.41 238.141 127.404 238.144Z'
      fill='#727785'
    />
    <path
      d='M116.914 232.098C116.949 231.6 117.119 231.089 117.515 230.719C116.534 230.821 116.18 231.116 115.802 231.544C114.888 232.58 115.501 233.719 116.064 233.488C116.627 233.257 116.878 232.614 116.914 232.098Z'
      fill='#E5E6ED'
    />
    <path
      d='M116.913 231.025C115.921 231.603 115.629 232.963 115.538 233.632L115.672 233.655C115.747 232.263 116.378 231.344 116.913 231.025C116.93 231.015 116.948 231.006 116.965 230.996C116.948 231.005 116.931 231.015 116.913 231.025Z'
      fill='#727785'
    />
    <path
      d='M116.004 231.453C115.85 231.678 115.925 231.999 115.973 232.152L116.004 232.143C115.879 231.837 115.921 231.576 116.004 231.453C116.006 231.449 116.009 231.445 116.012 231.441C116.009 231.445 116.006 231.449 116.004 231.453Z'
      fill='#727785'
    />
    <path
      d='M116.514 231.602C116.438 231.732 116.271 231.77 116.189 231.783L116.187 231.765C116.357 231.755 116.472 231.672 116.514 231.602C116.515 231.6 116.516 231.598 116.517 231.596C116.516 231.598 116.515 231.6 116.514 231.602Z'
      fill='#727785'
    />
    <path
      d='M115.635 231.972C115.544 232.229 115.699 232.52 115.785 232.655L115.813 232.639C115.613 232.375 115.586 232.112 115.635 231.972C115.636 231.968 115.638 231.963 115.64 231.959C115.638 231.963 115.636 231.968 115.635 231.972Z'
      fill='#727785'
    />
    <path
      d='M116.496 232.074C116.362 232.311 116.04 232.383 115.881 232.406L115.875 232.375C116.206 232.354 116.422 232.202 116.496 232.074C116.499 232.07 116.501 232.066 116.503 232.062C116.501 232.066 116.499 232.07 116.496 232.074Z'
      fill='#727785'
    />
    <path
      d='M116.54 232.591C116.353 232.935 115.921 233.049 115.709 233.087L115.702 233.042C116.143 233.001 116.437 232.777 116.54 232.591C116.544 232.585 116.547 232.579 116.55 232.573C116.547 232.579 116.544 232.585 116.54 232.591Z'
      fill='#727785'
    />
    <path
      d='M106.466 232.001C106.449 231.708 106.352 231.406 106.123 231.185C106.699 231.253 106.905 231.429 107.124 231.683C107.654 232.299 107.285 232.965 106.956 232.825C106.626 232.685 106.483 232.305 106.466 232.001Z'
      fill='#E5E6ED'
    />
    <path
      d='M106.474 231.37C107.054 231.718 107.216 232.52 107.264 232.914L107.186 232.927C107.152 232.107 106.787 231.562 106.474 231.37C106.464 231.364 106.454 231.358 106.444 231.353C106.454 231.358 106.464 231.364 106.474 231.37Z'
      fill='#727785'
    />
    <path
      d='M107.006 231.629C107.095 231.762 107.049 231.951 107.019 232.04L107.001 232.035C107.077 231.856 107.054 231.702 107.006 231.629C107.004 231.627 107.003 231.624 107.001 231.622C107.003 231.624 107.004 231.627 107.006 231.629Z'
      fill='#727785'
    />
    <path
      d='M106.705 231.712C106.749 231.789 106.847 231.813 106.895 231.82L106.896 231.81C106.796 231.803 106.729 231.753 106.705 231.712C106.704 231.711 106.704 231.709 106.703 231.708C106.704 231.709 106.704 231.711 106.705 231.712Z'
      fill='#727785'
    />
    <path
      d='M107.219 231.937C107.271 232.088 107.178 232.258 107.126 232.337L107.11 232.328C107.229 232.174 107.247 232.019 107.219 231.937C107.218 231.934 107.218 231.931 107.217 231.929C107.218 231.931 107.218 231.934 107.219 231.937Z'
      fill='#727785'
    />
    <path
      d='M106.712 231.99C106.789 232.13 106.978 232.175 107.071 232.19L107.075 232.171C106.881 232.156 106.755 232.066 106.712 231.99C106.71 231.987 106.709 231.985 106.708 231.982C106.709 231.985 106.71 231.987 106.712 231.99Z'
      fill='#727785'
    />
    <path
      d='M106.682 232.294C106.79 232.497 107.043 232.568 107.168 232.592L107.172 232.565C106.913 232.538 106.742 232.404 106.682 232.294C106.68 232.29 106.679 232.287 106.677 232.283C106.678 232.287 106.68 232.29 106.682 232.294Z'
      fill='#727785'
    />
    <path
      d='M124.759 235.47C124.776 235.176 124.873 234.875 125.103 234.654C124.527 234.721 124.32 234.897 124.101 235.152C123.571 235.768 123.94 236.434 124.269 236.294C124.599 236.154 124.742 235.774 124.759 235.47Z'
      fill='#E5E6ED'
    />
    <path
      d='M124.751 234.839C124.172 235.186 124.01 235.988 123.961 236.383L124.04 236.395C124.074 235.575 124.438 235.03 124.751 234.839C124.761 234.833 124.771 234.827 124.781 234.821C124.771 234.827 124.761 234.833 124.751 234.839Z'
      fill='#727785'
    />
    <path
      d='M124.219 235.097C124.13 235.23 124.177 235.418 124.206 235.508L124.225 235.503C124.149 235.323 124.172 235.169 124.219 235.097C124.221 235.094 124.223 235.092 124.224 235.09C124.223 235.092 124.221 235.094 124.219 235.097Z'
      fill='#727785'
    />
    <path
      d='M124.52 235.181C124.477 235.257 124.379 235.281 124.33 235.289L124.329 235.279C124.429 235.272 124.496 235.222 124.52 235.181C124.521 235.179 124.522 235.178 124.522 235.177C124.522 235.178 124.521 235.179 124.52 235.181Z'
      fill='#727785'
    />
    <path
      d='M124.006 235.405C123.954 235.557 124.048 235.727 124.099 235.806L124.116 235.796C123.996 235.643 123.979 235.488 124.006 235.405C124.007 235.403 124.008 235.4 124.009 235.397C124.008 235.4 124.007 235.403 124.006 235.405Z'
      fill='#727785'
    />
    <path
      d='M124.514 235.459C124.436 235.599 124.247 235.644 124.154 235.659L124.15 235.64C124.345 235.625 124.471 235.534 124.514 235.459C124.515 235.456 124.516 235.454 124.518 235.451C124.516 235.454 124.515 235.456 124.514 235.459Z'
      fill='#727785'
    />
    <path
      d='M124.543 235.763C124.435 235.966 124.182 236.036 124.057 236.06L124.053 236.034C124.313 236.007 124.484 235.873 124.543 235.763C124.545 235.759 124.547 235.756 124.549 235.752C124.547 235.755 124.545 235.759 124.543 235.763Z'
      fill='#727785'
    />
    <path
      d='M121.341 215.555H125.236L134.088 243.174H112.489L121.341 215.555Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M121.341 215.555H125.236L128.811 226.709H117.766L121.341 215.555ZM116.744 229.895L115.439 233.967H131.137L129.832 229.895H116.744ZM114.418 237.154H132.159L134.088 243.174H112.489L114.418 237.154Z'
      fill='#809FFF'
    />
    <rect x={107} y={243.174} width={32.5765} height={2.47864} fill='#809FFF' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M112.489 243.174L113.34 240.519H133.237L134.088 243.174H112.489Z'
      fill='black'
      fillOpacity={0.2}
    />
    <mask
      id='mask0_936_285'
      style={{
        maskType: 'alpha',
      }}
      maskUnits='userSpaceOnUse'
      x={107}
      y={215}
      width={33}
      height={31}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M121.341 215.555H125.236L128.811 226.709H117.766L121.341 215.555ZM116.744 229.895L115.439 233.967H131.137L129.832 229.895H116.744ZM114.418 237.154H132.159L134.088 243.174H112.489L114.418 237.154Z'
        fill='#2F63FF'
      />
      <rect
        x={107}
        y={243.174}
        width={32.5765}
        height={2.47864}
        fill='#2F63FF'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M112.489 243.174L113.34 240.519H133.237L134.088 243.174H112.489Z'
        fill='black'
        fillOpacity={0.2}
      />
    </mask>
    <g mask='url(#mask0_936_285)'>
      <circle
        cx={102.751}
        cy={208.827}
        r={33.1076}
        fill='white'
        fillOpacity={0.2}
      />
    </g>
    <path
      d='M2 247H402'
      stroke='#20242E'
      strokeWidth={4}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <rect x={148} y={123} width={6} height={122} fill='#20242E' />
    <rect x={143} y={123} width={8} height={122} fill='#334680' />
    <rect x={256} y={123} width={6} height={122} fill='#20242E' />
    <rect x={251} y={123} width={8} height={122} fill='#334680' />
    <rect x={123} y={134} width={158} height={22.5714} fill='#809FFF' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M259.631 156.571H281V134H268.541L259.631 156.571ZM255.562 134H227.719L218.809 156.571H246.652L255.562 134ZM186.898 134H214.741L205.831 156.571H177.988L186.898 134ZM173.919 134H146.076L137.167 156.571H165.009L173.919 134ZM123 134H133.098L124.188 156.571H123V134Z'
      fill='white'
    />
    <path
      opacity={0.2}
      fillRule='evenodd'
      clipRule='evenodd'
      d='M177.63 156.571L190.662 134H236.339L249.37 156.571H177.63Z'
      fill='#20242E'
    />
    <rect
      opacity={0.2}
      x={123}
      y={134}
      width={158}
      height={2.39}
      fill='#20242E'
    />
    <rect x={123} y={175} width={158} height={22.5714} fill='#809FFF' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M259.631 197.571H281V175H268.541L259.631 197.571ZM255.562 175H227.719L218.809 197.571H246.652L255.562 175ZM186.898 175H214.741L205.831 197.571H177.988L186.898 175ZM173.919 175H146.076L137.167 197.571H165.009L173.919 175ZM123 175H133.098L124.188 197.571H123V175Z'
      fill='white'
    />
    <path
      opacity={0.2}
      fillRule='evenodd'
      clipRule='evenodd'
      d='M257.141 175L257.881 176.282C261.743 182.971 256.916 191.332 249.192 191.332H169.251C161.527 191.332 156.699 182.971 160.561 176.282L161.301 175H257.141Z'
      fill='#20242E'
    />
    <rect
      opacity={0.2}
      x={123}
      y={175}
      width={158}
      height={2.39}
      fill='#20242E'
    />
    <path
      d='M194.041 100.405C198.008 93.5333 207.927 93.5333 211.895 100.405L252.959 171.53C256.926 178.402 251.967 186.992 244.032 186.992H161.904C153.969 186.992 149.01 178.402 152.977 171.53L194.041 100.405Z'
      fill='#2854D9'
    />
    <path
      d='M208.219 100.462L249.283 171.587C252.48 177.125 248.483 184.048 242.088 184.048H159.96C153.565 184.048 149.568 177.125 152.765 171.587L193.829 100.462C197.027 94.9233 205.021 94.9233 208.219 100.462Z'
      fill='white'
      stroke='#2F63FF'
      strokeWidth={4}
    />
    <path
      d='M189.698 170.608V166.008H187.458V159.528H182.218V166.008H176.898L184.778 147.408H179.538L171.658 166.008V170.608H182.218V175.008H187.458V170.608H189.698ZM195.117 173.088C196.477 174.688 198.557 175.448 201.357 175.448C204.157 175.448 206.197 174.648 207.557 173.048C208.917 171.448 209.597 169.088 209.597 165.928V156.168C209.597 153.128 208.917 150.848 207.557 149.288C206.197 147.768 204.157 146.968 201.357 146.968C198.637 146.968 196.597 147.768 195.197 149.328C193.797 150.888 193.117 153.168 193.117 156.168V165.928C193.117 169.128 193.757 171.488 195.117 173.088ZM203.717 169.688C203.317 170.488 202.517 170.888 201.357 170.888C200.197 170.888 199.397 170.488 198.997 169.688C198.597 168.888 198.397 167.488 198.397 165.488V156.928C198.397 154.968 198.597 153.568 198.997 152.768C199.397 151.968 200.157 151.568 201.357 151.568C202.517 151.568 203.317 151.968 203.717 152.768C204.117 153.568 204.357 154.968 204.357 156.928V165.488C204.357 167.488 204.117 168.888 203.717 169.688ZM215.506 173.608C216.946 174.848 218.946 175.448 221.546 175.448C223.106 175.448 224.506 175.128 225.786 174.488C227.026 173.848 227.986 172.888 228.706 171.688C229.386 170.488 229.746 169.088 229.746 167.448V166.688C229.746 165.168 229.426 163.848 228.786 162.728C228.146 161.648 227.266 160.848 226.066 160.328C227.106 159.768 227.906 159.048 228.466 158.088C229.026 157.128 229.306 156.048 229.306 154.848V154.248C229.306 152.048 228.586 150.288 227.226 148.968C225.826 147.648 223.906 146.968 221.506 146.968C219.026 146.968 217.066 147.648 215.666 148.928C214.266 150.208 213.586 152.008 213.586 154.328V155.008H218.386V154.328C218.386 153.448 218.626 152.728 219.146 152.208C219.626 151.688 220.346 151.408 221.306 151.408C222.186 151.408 222.906 151.728 223.426 152.288C223.946 152.848 224.226 153.648 224.226 154.648V155.248C224.226 156.288 223.946 157.128 223.386 157.688C222.826 158.288 222.026 158.568 221.026 158.568H219.666V163.008H221.066C222.226 163.008 223.106 163.328 223.746 163.968C224.346 164.608 224.666 165.528 224.666 166.728V167.448C224.666 168.568 224.346 169.408 223.786 170.048C223.226 170.688 222.426 171.008 221.466 171.008C220.426 171.008 219.626 170.768 219.066 170.288C218.506 169.808 218.266 169.048 218.266 168.088V167.488H213.386V168.328C213.386 170.608 214.066 172.368 215.506 173.608Z'
      fill='#2F63FF'
    />
    <path
      d='M199.628 128.29H202.718L203.498 118.03L203.648 113.56H198.698L198.848 118.03L199.628 128.29ZM201.188 136.3C202.688 136.3 203.828 135.19 203.828 133.63C203.828 132.07 202.688 130.99 201.188 130.99C199.658 130.99 198.518 132.07 198.518 133.63C198.518 135.19 199.628 136.3 201.188 136.3Z'
      fill='#2F63FF'
    />
  </svg>
);
export default Forbidden;
